module.exports = __webpack_public_path__ + "img/Pierce.06e8361d.jpg";